/**
 * React Query hooks for Microsoft integration
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import type { IntegrationTileQueryOptions } from '../../api/integrationTileQuery';
import { microsoftIntegrationApi, MicrosoftIntegrationStatus } from '../services/microsoftIntegrationApi';

const INTEGRATION_QUERY_KEY = 'microsoft-integration';

/**
 * Fetch Microsoft integration status. See `useGoogleIntegration` for why the
 * refetch cadence is opt-in per call site rather than baked into the hook.
 */
export function useMicrosoftIntegration(options?: IntegrationTileQueryOptions) {
  return useQuery<{ data: MicrosoftIntegrationStatus }>({
    queryKey: [INTEGRATION_QUERY_KEY],
    queryFn: () => microsoftIntegrationApi.getStatus(),
    ...options,
  });
}

export function useInitiateMicrosoftAuth() {
  return useMutation({
    mutationFn: (scopes?: string[]) => microsoftIntegrationApi.initiateAuth(scopes),
  });
}

export function useDisconnectMicrosoft() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => microsoftIntegrationApi.disconnect(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [INTEGRATION_QUERY_KEY] });
    },
  });
}
